module.exports = __webpack_public_path__ + "img/1-light.01f210c5.png";